// eslint-disable-next-line @nx/enforce-module-boundaries
import { type SurveysCheckDisplayComponentType } from '@credit-web/services/types'

import { SurveysQuestionTypeEnum } from '../entities'

export const mapApiComponentType = (
  apiComponentType?: SurveysCheckDisplayComponentType | null
): SurveysQuestionTypeEnum => {
  if (!apiComponentType) return SurveysQuestionTypeEnum.Unavailable

  // Handle FreeText if it exists in the API type
  const apiComponentTypeStr = String(apiComponentType)
  if (apiComponentTypeStr === 'FreeText') {
    return SurveysQuestionTypeEnum.FreeText
  }

  const mapping: Partial<Record<SurveysCheckDisplayComponentType, SurveysQuestionTypeEnum>> = {
    Score: SurveysQuestionTypeEnum.Score,
    MultipleChoice: SurveysQuestionTypeEnum.MultipleChoice,
    YesNo: SurveysQuestionTypeEnum.YesNo,
    MultipleChoiceSingle: SurveysQuestionTypeEnum.MultipleChoiceSingle
  }

  return mapping[apiComponentType] || SurveysQuestionTypeEnum.Unavailable
}
